require("./accounts.coffee");
require("./admin.coffee");
require("./bug_reports.coffee");
require("./health_grade_key.coffee");
require("./job_builders.coffee");
require("./questionnaires.coffee");
require("./site_templates.coffee");
require("../global/icon_picker_widget.coffee");
